import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { Page } from '../../../components/shared/page/Page';
import { AssessmentListFilterForm } from '../../../features/assessments/components/assessment-list-filter/AssessmentListFilter';
import { MultipleChoiceAssessmentAttemptDialog } from '../../../features/assessments/components/multiple-choice-assessment-attempt-dialog/MultipleChoiceAssessmentAttemptDialog';
import { MultipleChoiceAssessmentGroupedList } from '../../../features/assessments/components/multiple-choice-assessment-grouped-list/MultipleChoiceAssessmentGroupedList';

function MultipleChoiceFormativeAssessmentListPage() {
  const { subjectId } = useParams();

  const [filter, setFilter] = useState<AssessmentListFilterForm>({
    fromTime: new Date('2010-01-01'),
    toTime: new Date(),
    sort: 'releaseDate',
    subject: {
      id: subjectId!,
      name: '',
    },
    perspectives: ['instructor'],
    statuses: ['published'],
    purposes: ['formative'],
    referenceStandards: ['criterion-referenced'],
    methodologies: ['quantitative'],
    settings: ['formal'],
    official: false,
    released: true,
  });

  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      subject: {
        id: subjectId!,
        name: '',
      },
    }));
  }, [subjectId]);

  const [selectedAssessmentId, setSelectedAssessmentId] = useState<string>();

  return (
    <Page title="Simulacros esenciales">
      <MultipleChoiceAssessmentGroupedList
        filter={filter}
        onSelected={(assessmentId: string) =>
          setSelectedAssessmentId(assessmentId)
        }
      />
      <MultipleChoiceAssessmentAttemptDialog
        subjectId={subjectId!}
        assessmentId={selectedAssessmentId}
        onClose={() => setSelectedAssessmentId(undefined)}
      />
    </Page>
  );
}

export { MultipleChoiceFormativeAssessmentListPage };
